import withInputErrorMessage from '../withInputErrorMessage';
import withOptionsSelectValueInitById from './withOptionsSelectValueInitById';
import withFormikSelect from './withSelectFormik';

const options = [
   { id: '01', value: '01', label: 'Jan' },
   { id: '02', value: '02', label: 'Feb' },
   { id: '03', value: '03', label: 'Mar' },
   { id: '04', value: '04', label: 'Apr' },
   { id: '05', value: '05', label: 'May' },
   { id: '06', value: '06', label: 'Jun' },
   { id: '07', value: '07', label: 'Jul' },
   { id: '08', value: '08', label: 'Aug' },
   { id: '09', value: '09', label: 'Sep' },
   { id: '10', value: '10', label: 'Oct' },
   { id: '11', value: '11', label: 'Nov' },
   { id: '12', value: '12', label: 'Dec' },
];

export default withFormikSelect(withInputErrorMessage(withOptionsSelectValueInitById(options)));
